import { useMemo } from "react";
import { Market } from "../../../types/workspace";
import { useMarketSummary } from "./useMarketSummary";
import { useConfigurationFilters } from "./useConfigurationFilters";
import { useWorkspaceStore } from "../../../store/workspace/WorkspaceStore";
import { OpportunityType } from "../../../legacy/types/companyFilter";

export const useGetMarketSize = () => {
  const workspace = useWorkspaceStore((state) => state.draft);
  const whitespace = useWorkspaceStore(
    (state) => state.draft?.configuration?.whitespace
  );

  const localizeInstalls = useWorkspaceStore(
    (state) => state.draft?.configuration?.localizeInstalls ?? true
  );
  const tamFilter = useConfigurationFilters(workspace, Market.TAM);
  const samFilter = useConfigurationFilters(workspace, Market.SAM);
  const somFilter = useConfigurationFilters(workspace, Market.SOM);

  const tam = useMarketSummary({
    companyFilters: tamFilter,
    spendCategoryWeights: workspace?.configuration.tam.spendCategoryWeights,
    spendType: workspace?.configuration.tam.spendType,
    localizeInstalls,
  });

  const tamExpansion = useMarketSummary({
    companyFilters: {
      ...tamFilter,
      opportunityType: { type: OpportunityType.EXPANSION_WHITESPACE },
    },
    spendCategoryWeights: workspace?.configuration.tam.spendCategoryWeights,
    spendType: workspace?.configuration.tam.spendType,
    localizeInstalls,
    skip: !whitespace?.enableHierarchyClassification || !whitespace?.fileId,
  });

  const sam = useMarketSummary({
    companyFilters: samFilter,
    spendCategoryWeights: workspace?.configuration.tam.spendCategoryWeights,
    spendType: workspace?.configuration.tam.spendType,
    localizeInstalls,
  });

  const samExpansion = useMarketSummary({
    companyFilters: {
      ...samFilter,
      opportunityType: { type: OpportunityType.EXPANSION_WHITESPACE },
    },
    spendCategoryWeights: workspace?.configuration.tam.spendCategoryWeights,
    spendType: workspace?.configuration.tam.spendType,
    localizeInstalls,
    skip: !whitespace?.enableHierarchyClassification || !whitespace?.fileId,
  });

  const som = useMarketSummary({
    companyFilters: somFilter,
    spendCategoryWeights: workspace?.configuration.tam.spendCategoryWeights,
    spendType: workspace?.configuration.tam.spendType,
    localizeInstalls,
  });
  const somExpansion = useMarketSummary({
    companyFilters: {
      ...somFilter,
      opportunityType: { type: OpportunityType.EXPANSION_WHITESPACE },
    },
    spendCategoryWeights: workspace?.configuration.tam.spendCategoryWeights,
    spendType: workspace?.configuration.tam.spendType,
    localizeInstalls,
    skip: !whitespace?.enableHierarchyClassification || !whitespace?.fileId,
  });

  const isLoading = useMemo(() => {
    return tam.loading || sam.loading || som.loading;
  }, [sam.loading, som.loading, tam.loading]);

  return {
    tam,
    tamExpansion,
    sam,
    samExpansion,
    som,
    somExpansion,
    isLoading,
  };
};
